import { render } from "./Privacidade.vue?vue&type=template&id=10b60eba&scoped=true"
import script from "./Privacidade.vue?vue&type=script&lang=js"
export * from "./Privacidade.vue?vue&type=script&lang=js"

import "./Privacidade.vue?vue&type=style&index=0&id=10b60eba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10b60eba"]])

export default __exports__